import type { CalendarApi } from "../../api/CalendarApi";
import type { CreateDatetimeRange } from "../../generated/dto/CreateDatetimeRange";
import type { CreateSunsetTime } from "../../generated/dto/CreateSunsetTime";
import type { CreateYearlyDate } from "../../generated/dto/CreateYearlyDate";
import type { CreateYearlyDateItem } from "../../generated/dto/CreateYearlyDateItem";
import type { DatetimeRangeStaff } from "../../generated/dto/DatetimeRangeStaff";
import type { DeleteDatetimeRangeStaff } from "../../generated/dto/DeleteDatetimeRangeStaff";
import type { DeleteSunsetTimeStaff } from "../../generated/dto/DeleteSunsetTimeStaff";
import type { DeleteYearlyDateItemStaff } from "../../generated/dto/DeleteYearlyDateItemStaff";
import type { DeleteYearlyDateStaff } from "../../generated/dto/DeleteYearlyDateStaff";
import type { SunsetTimeStaff } from "../../generated/dto/SunsetTimeStaff";
import type { UpdateDatetimeRange } from "../../generated/dto/UpdateDatetimeRange";
import type { UpdateSunsetTime } from "../../generated/dto/UpdateSunsetTime";
import type { UpdateYearlyDate } from "../../generated/dto/UpdateYearlyDate";
import type { UpdateYearlyDateItem } from "../../generated/dto/UpdateYearlyDateItem";
import type { YearlyDateFetchOptions } from "../../generated/dto/YearlyDateFetchOptions";
import type { YearlyDateItemStaff } from "../../generated/dto/YearlyDateItemStaff";
import type { YearlyDateStaff } from "../../generated/dto/YearlyDateStaff";

export class CalendarFrontendService {
  constructor(private readonly api: CalendarApi) {}
  async getSunsetTimeStaff(id: number): Promise<SunsetTimeStaff> {
    return this.api.getSunsetTimeStaff(id)
  }
  async getDatetimeRangeStaff(id: number): Promise<DatetimeRangeStaff> {
    return this.api.getDatetimeRangeStaff(id)
  }
  async getYearlyDateItemStaff(id: number): Promise<YearlyDateItemStaff> {
    return this.api.getYearlyDateItemStaff(id)
  }
  async getYearlyDateStaff(id: number, options?: YearlyDateFetchOptions): Promise<YearlyDateStaff> {
    return this.api.getYearlyDateStaff(id, options)
  }
  async createSunsetTimeStaff(source: CreateSunsetTime): Promise<SunsetTimeStaff> {
    return this.api.createSunsetTimeStaff(source)
  }
  async createDatetimeRangeStaff(source: CreateDatetimeRange): Promise<DatetimeRangeStaff> {
    return this.api.createDatetimeRangeStaff(source)
  }
  async createYearlyDateItemStaff(source: CreateYearlyDateItem): Promise<YearlyDateItemStaff> {
    return this.api.createYearlyDateItemStaff(source)
  }
  async createYearlyDateStaff(source: CreateYearlyDate): Promise<YearlyDateStaff> {
    return this.api.createYearlyDateStaff(source)
  }
  async updateSunsetTimeStaff(source: UpdateSunsetTime): Promise<SunsetTimeStaff> {
    return this.api.updateSunsetTimeStaff(source)
  }
  async updateDatetimeRangeStaff(source: UpdateDatetimeRange): Promise<DatetimeRangeStaff> {
    return this.api.updateDatetimeRangeStaff(source)
  }
  async updateYearlyDateItemStaff(source: UpdateYearlyDateItem): Promise<YearlyDateItemStaff> {
    return this.api.updateYearlyDateItemStaff(source)
  }
  async updateYearlyDateStaff(source: UpdateYearlyDate): Promise<YearlyDateStaff> {
    return this.api.updateYearlyDateStaff(source)
  }
  async deleteSunsetTimeStaff(source: DeleteSunsetTimeStaff): Promise<void> {
    return this.api.deleteSunsetTimeStaff(source)
  }
  async deleteDatetimeRangeStaff(source: DeleteDatetimeRangeStaff): Promise<void> {
    return this.api.deleteDatetimeRangeStaff(source)
  }
  async deleteYearlyDateItemStaff(source: DeleteYearlyDateItemStaff): Promise<void> {
    return this.api.deleteYearlyDateItemStaff(source)
  }
  async deleteYearlyDateStaff(source: DeleteYearlyDateStaff): Promise<void> {
    return this.api.deleteYearlyDateStaff(source)
  }
  async getYearlyDateStaffItemId(id: number): Promise<YearlyDateItemStaff | null> {
    return this.api.getYearlyDateStaffItemId(id)
  }
}
